<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ partner.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PartnersTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CInput
                            v-model="partner.title"
                            label="Название"
                            :horizontal="true"
                        />
                        <CInput
                            v-model="partner.legal_entity"
                            label="Юр. лицо"
                            :horizontal="true"
                        />
                        <CInput
                            v-model="partner.individual_taxpayer_number"
                            label="ИНН"
                            :horizontal="true"
                        />
                        <CSelect
                            :value.sync="partner.vat"
                            :horizontal="true"
                            :options="vatOptions"
                            label="Значения ставки НДС"
                            placeholder="Выберите значения ставки НДС"
                        />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Использовать значения ставки НДС для каждого товара свою</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="partner.use_product_vat"
                                />
                            </CCol>
                        </CRow>
                        <CSelect
                            :value.sync="partner.payment"
                            :horizontal="true"
                            :options="paymentTypeOptions"
                            label="Тип оплаты"
                            placeholder="Выберите тип оплаты"
                        />
                        
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Признак способа расчета
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :value.sync="partner.pre_receipt_method"
                                    :horizontal="true"
                                    :options="receiptMethods"
                                    label="Чек аванса"
                                    placeholder="Чек аванса"
                                />
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    :value.sync="partner.final_receipt_method"
                                    :horizontal="true"
                                    :options="receiptMethods"
                                    label="Финальный чек"
                                    placeholder="Финальный чек"
                                />
                            </CCol>
                        </CRow>
                        <CSelect
                            :value.sync="partner.receipt_object"
                            :horizontal="true"
                            :options="receiptObjects"
                            label="Предмет расчета"
                            placeholder="Предмет расчета"
                        />

                        <CInput
                            v-model="partner.contract_id"
                            label="№ договора"
                            :horizontal="true"
                        />
                        <CInput
                            v-model="partner.phone"
                            label="Номер телефона партнера"
                            :horizontal="true"
                        />
                        <PartnerSignersUpdate :signers="partner.signers" @set-signers="setSigners" />
                        <CRow class="mb-3">
                            <CCol cols="12" md="3"> Дата договора: </CCol>
                            <CCol
                                cols="12"
                                md="9"
                                class="pl-2">
                                <DatePicker
                                    v-model="datepicker.date"
                                    :language="datepicker.lang"
                                    :format="datepicker.format"
                                    input-class="custom-datepicker"
                                    placeholder="Выберите дату..."
                                />
                            </CCol>
                        </CRow>
                        <PartnerReportSettings :partner="partner" @set-frequency="setReportFrequency" @set-emails="setReportEmails" />
                        <CInput
                            v-model="partner.telegram_chat_id"
                            label="Телеграм чат"
                            :horizontal="true"
                        />
                        <CRow class="mb-2">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label align-items-center d-flex mb-1">Пользователи телеграм бота</CCol>
                            <CCol 
                                class="pt-2 pb-2" 
                                sm="9">
                                <CRow class="mb-1">
                                    <CCol class="align-items-center d-flex">
                                        <CInput
                                            v-model="userPhone"
                                            placeholder="Номер телефона"
                                            type="tel"
                                            class="m-0"
                                        />
                                        <CButton
                                            size="sm"
                                            shape="pill"
                                            color="success"
                                            variant="outline"
                                            class="ml-3"
                                            @click="createTelegramUser"
                                         >Создать</CButton>
                                    </CCol>    
                                </CRow>
                            </CCol>  
                        </CRow>

                        <!-- <CInput
                            v-model="partner.max_bot_id"
                            label="MAX бот"
                            :horizontal="true"
                        /> -->
                        <CInput
                            v-model="partner.max_chat_id"
                            label="MAX чат для заказов"
                            :horizontal="true"
                        />
                        
                        <CRow v-if="telegramUsers.length !== 0" class="pl-3 pb-3 pr-3"> 
                            <table class="table">
                                <thead>
                                    <th>Имя</th>
                                    <th>Телефон</th>
                                    <th></th>
                                </thead>
                                    <tr v-for="user in telegramUsers" :key="user.first_name">
                                        <td>{{ user.first_name }}</td>
                                        <td>{{ user.phone }} </td>
                                        <td>
                                            <CButton
                                                size="sm"
                                                shape="pill"
                                                color="success"
                                                variant="outline"
                                                class="handle"
                                                @click="deleteTelegramUser(user.first_name).reset()"
                                            > Удалить </CButton>
                                        </td>
                                    </tr>
                            </table>
                        </CRow>
                        <CInput
                            v-model.number="partner.notification_delay"
                            label="Задержка повтора уведомления о непринятом заказе (в секундах)*"
                            placeholder="Задержка"
                        />
                        <CInput
                            v-model.number="partner.try_count"
                            label="Макс. кол-во уведомлений о непринятом заказе*"
                            placeholder="Кол-во уведомлений"
                        />
                        <CInput
                            v-model="partner.mircity_commission"
                            label="Комиссия МИРСИТИ (%)"
                            :horizontal="true"
                        />
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Отключить применение тарифов по зонам</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="partner.delivery_zone_disabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Активен</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="partner.enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Архив</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="partner.archive"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="mr-3"
                        @click="deleteModal = true"
                    >Удалить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>
                        Вы действительно хотите удалить партнера? Это действие нельзя будет
                        отменить.
                    </p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="deletePartner"
                    >Удалить</CButton
                    >
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnersTabLinks from '@/components/partner/PartnersTabLinks';
    import PartnerSignersUpdate from '@/components/partner/PartnerSignersUpdate';
    import PartnerReportSettings from '@/components/partner/PartnerReportSettings';
    import { PAYMENT_TYPE } from '../../utils/payment';
    import { paymentTypeTitle } from '../../utils/payment-views';
    import DatePicker from 'vuejs-datepicker';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import moment from 'moment';

    export default {

        name: 'PartnerEdit',
        components: {
            PartnersTabLinks,
            PartnerSignersUpdate,
            PartnerReportSettings,
            DatePicker
        },

        data() {
            return {
                partner: {
                    id: 0,
                    title: '',
                    payment: 1,
                    telegram_chat_id: '',
                    max_bot_id: '',
                    max_chat_id: '',
                    contract_id: '',
                    phone: '',
                    contract_date: '',
                    notification_delay: null,
                    try_count: null,
                    mircity_commission: 0,
                    use_product_vat: false,
                    enabled: false,
                    archive: false,
                    delivery_zone_disabled: false,
                    partnerTelegramUser: null
                },
                telegramUsers: [],
                signers: [],
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    date: null,
                },
                deleteModal: false,
                addUser: true,
                userPhone: null,
                vatOptions: [
                    { value: null, label: 'НДС не облагается' },
                    { value: 0, label: 'НДС 0%' },
                    { value: 5, label: 'НДС 5%' },
                    { value: 7, label: 'НДС 7%' },
                    { value: 10, label: 'НДС 10%' },
                    { value: 20, label: 'НДС 20%' },
                    { value: 22, label: 'НДС 22%' },
                    { value: 105, label: 'Расчетный НДС 5/105' },
                    { value: 107, label: 'Расчетный НДС 7/107' },
                    { value: 110, label: 'Расчетный НДС 10/110' },
                    { value: 120, label: 'Расчетный НДС 20/120' },
                    { value: 12, label: 'НДС 12% (только для онлайн-касс в Казахстане)' },
                ],
                receiptMethods: [
                    { value: 0, label: 'Unknown, неизвестный способ расчета' },
                    { value: 1, label: 'FullPrepayment, предоплата 100%' },
                    { value: 2, label: 'PartialPrepayment, предоплата' },
                    { value: 3, label: 'AdvancePay, аванс' },
                    { value: 4, label: 'FullPay, полный расчёт' },
                    { value: 5, label: 'PartialPayAndCredit, частичный расчёт и кредит' },
                    { value: 6, label: 'Credit, передача в кредит' },
                    { value: 7, label: 'CreditPayment, оплата кредита' },
                ],
                receiptObjects: [
                    { value: 0, label: 'Unknown, неизвестный предмет оплаты' },
                    { value: 1, label: 'Commodity, товар' },
                    { value: 2, label: 'ExcisedCommodity, подакцизный товар' },
                    { value: 3, label: 'Job, работа' },
                    { value: 4, label: 'Service, услуга' },
                    // { value: 5, label: 'GamblingBet, ставка азартной игры' },
                    // { value: 6, label: 'GamblingWin, выигрыш азартной игры' },
                    // { value: 7, label: 'LotteryTicket, лотерейный билет' },
                    // { value: 8, label: 'LotteryWin, выигрыш лотереи' },
                    // { value: 9, label: 'RidAccess, предоставление РИД' },
                    { value: 10, label: 'Payment, платеж' },
                    { value: 11, label: 'AgentReward, агентское вознаграждение' },
                    // { value: 12, label: 'Composite, Выплата' },
                    { value: 13, label: 'Another, иной предмет расчета' },
                    // { value: 14, label: 'PropertyLaw, Имущественное право' },
                    // { value: 15, label: 'NonOperatingIncome, Внереализационный доход' },
                    // { value: 16, label: 'InsuranceContributions, Страховые взносы' },
                    // { value: 17, label: 'TradeFee, Торговый сбор' },
                    // { value: 18, label: 'ResortFee, Курортный сбор' },
                    // { value: 19, label: 'CautionMoney, Залог' },
                    // { value: 20, label: 'ExpensesIncurred, Расход' },
                    // { value: 21, label: 'ContributionsOnIp, Взносы на обязательное пенсионное страхование ИП' },
                    // { value: 22, label: 'ContributionsSimple, Взносы на обязательное пенсионное страхование' },
                    // { value: 23, label: 'ContributionsMedical, Взносы на обязательное медицинское страхование ИП' },
                    // { value: 24, label: 'ContributionsMedicalSimple, Взносы на обязательное медицинское страхование' },
                    // { value: 25, label: 'ContributionsSocial, Взносы на обязательное социальное страхование' },
                    // { value: 26, label: 'CasinoPayment, Платеж казино' },
                    // { value: 27, label: 'CashWithdrawal, Выдача денежных средств (ффд 1.2)' },
                    // { value: 30, label: 'Atnm, АТНМ (ффд 1.2)' },
                    // { value: 31, label: 'Atm, АТМ (ффд 1.2)' },
                    // { value: 32, label: 'Tnm, ТНМ (ффд 1.2)' },
                    // { value: 33, label: 'Tm, ТМ (ффд 1.2)' },
                ]
            };
        },

        computed: { 
            paymentTypeOptions() {
                const options = [];
                for (const key in PAYMENT_TYPE) {
                    options.push({
                        value: PAYMENT_TYPE[key],
                        label: paymentTypeTitle(PAYMENT_TYPE[key]),
                    });
                }
                return options;
            },
        },

        async mounted() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const id = parseInt(this.$route.params.id);
                Vue.axios
                    .get('/partners/' + id)
                    .then(resp => {
                        resp.data.delivery_zone_disabled = !!resp.data.delivery_zone_disabled;
                        resp.data.archive = !!resp.data.archive;
                        this.partner = resp.data;
                        this.datepicker.date = moment(resp.data.contract_date).format('YYYY.MM.DD');
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });

                Vue.axios.get('/partners/telegram-users/' + id)
                    .then(resp => {
                        this.telegramUsers = resp.data;
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },

            save() {
                if (this.partner.notification_delay && !this.partner.try_count) {
                    this.$root.$emit('showError', 'Заполните макс. кол-во уведомлений!');
                    return;
                }
                if (this?.partner?.notification_delay && this?.partner?.notification_delay < 20) {
                    this.$root.$emit('showError', 'Задержка повтора уведомлений не может быть меньше чем 20 сек.');
                    return;
                }
                if (!this.partner.notification_delay && this.partner.try_count) {
                    this.$root.$emit('showError', 'Заполните задержку повтора уведомлений!');
                    return;
                }
                this.partner.contract_date = moment(this.datepicker.date).format('YYYY-MM-DD');
                if (typeof this.partner?.mircity_commission === 'string') {
                    this.partner.mircity_commission = this.partner.mircity_commission.replace(',', '.');
                }
                this.partner.mircity_commission = this.partner.mircity_commission ? parseFloat(this.partner.mircity_commission) : null;
                this.partner.notification_delay = this.partner.notification_delay ? +this.partner.notification_delay : null;
                this.partner.try_count = this.partner.try_count ? +this.partner.try_count : null;
                Vue.axios
                    .put('/partners/' + this.partner.id, this.partner)
                    .then(() => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });

                Vue.axios
                    .post(`/partners/signers/${this.partner.id}`, this.signers)
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            deletePartner() {
                Vue.axios
                    .delete('/partners/' + this.partner.id)
                    .then(() => {
                        this.$router.push({ path: '/partners' });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            deleteTelegramUser() {
                Vue.axios
                    .delete(`/partners/telegram-users/${this.partner.partnerTelegramUser.id}`)
                    .then(() => {
                        return this.fetch();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            createTelegramUser() {
                Vue.axios
                    .post('/partners/telegram-users', {
                        partner_id: this.partner.id,
                        phone: this.userPhone
                    })  
                    .then(() => {
                        return this.fetch();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Телеграм пользователь с таким номером не ожидает подключения к партнеру.');
                    });

                    this.userPhone = '';
            },

            setSigners(signers) {
                this.signers = signers.map(signer => ({ ...signer, partner_id: this.partner.id }));
            },

            setReportFrequency(frequency) {
                this.partner.report_frequency = frequency;
            },
            setReportEmails(emails) {
                this.partner.report_emails = emails;
            },

            goBack() {
                this.$router.push({ path: '/partners/' + this.partner.id });
            },
        },
    };
</script>

<style>
input.custom-datepicker {
  border: 1px solid;
  border-color: #d8dbe0;
  width: 100%;
  padding: 7px;
  border-radius: 4px;
}

.handle {
  cursor: pointer;
}
</style>
